import Constants from '../utils/consts';
import Utils from '../utils/utils';
import Cookies from 'universal-cookie';

var http = require('follow-redirects').https;
var qs = require('querystring');

export default async function updateClient(uname, token, id, ragioneSociale, indirizzo, citta, provincia, cap, mail, telefono, logo, c_db, ads, exp) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'updateClient.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            const resp = JSON.parse(body.toString())
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
            'token': token,
            'uname': uname,
            'id': id,
            'ragione_sociale': Utils.escapeString(ragioneSociale),
            'indirizzo': Utils.escapeString(indirizzo),
            'citta': Utils.escapeString(citta),
            'provincia': provincia,
            'CAP': cap,
            'mail': mail,
            'telefono': Utils.escapeString(telefono),
            'logo': logo, 
            'db_name': 'admin_db', 
            'client_db': c_db, 
            'ads_active': ads ? '0' : '1',
            'is_expirable': exp ? '1' : '0'
        });

        req.write(postData);

        req.end();
    });
}
